import { useState } from 'react'
import LmnDialog from 'src/components/Dialogs/Lmn/LmnDialog'
import { Button, Box, Typography } from '@mui/material'
import { ButtonProps, ButtonPropsSizeOverrides } from '@mui/material/Button'
import { OverridableStringUnion } from '@mui/types'
import { styled } from '@mui/material/styles'
import styles from './PaymentsButton.scss'

export interface LmnButtonProps {
  buttonColor?: string
  buttonFullWidth?: boolean
  buttonRadius?: string
  isFullScreen?: boolean
  label?: string
  onCancel: () => void
  merchantUuid: string
  size?: OverridableStringUnion<'small' | 'medium' | 'large', ButtonPropsSizeOverrides>
  textColor?: string
}

const LmnButton = ({
  buttonColor,
  buttonFullWidth,
  buttonRadius,
  isFullScreen,
  label,
  merchantUuid,
  onCancel,
  size,
  textColor,
}: LmnButtonProps): JSX.Element => {
  const [open, setOpen] = useState(false)
  const handleOpen = (): void => {
    setOpen(true)
  }
  const handleClose = (): void => {
    setOpen(false)
    if (typeof onCancel === 'function') {
      onCancel()
    }
  }

  const StyledButton = styled(Button)<ButtonProps>(() => ({
    color: textColor,
    backgroundColor: buttonColor,
    borderRadius: buttonRadius ?? '28px',
    '&:hover': {
      color: textColor,
      backgroundColor: buttonColor,
      borderRadius: buttonRadius ?? '28px',
    },

  }))

  return (
    <>
      <StyledButton
        fullWidth={buttonFullWidth}
        variant="contained"
        onClick={handleOpen}
        size={size}
      >
        <Box>
          {label ?? (
            <Typography className={styles.ButtonText} variant="body2Bold">
              REQUEST YOUR LMN
            </Typography>
          )}
        </Box>
      </StyledButton>
      <LmnDialog
        isOpen={open}
        isFullScreen={isFullScreen}
        merchantUuid={merchantUuid}
        onCancel={handleClose}
      />
    </>
  )
}

export default LmnButton
